export enum AnswerSubmissionErrorType {
    ExceededMaxRetryCount = 'EXCEEDED_MAX_RETRY_COUNT',
    ClientErrorResponse = 'CLIENT_ERROR_RESPONSE'
}
